import { Card, CardContent, CardHeader, Grid, IconButton } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { FormTextField, HiddenField } from 'shared/controls';
import { PdfExpenseForm } from 'shared/types';
import { buildFieldExpenseNameWithIndex } from 'shared/utility';
import { useFormContext } from 'react-hook-form';

interface PdfExpenseFieldsProps {
  expense: PdfExpenseForm;
  index: number;
  isSummaryExpense?: boolean;
  moveUp(): void;
  moveDown(): void;
  disableMoveUp: boolean;
  disableMoveDown: boolean;
}
export function PdfExpenseFields({
  index,
  moveDown,
  moveUp,
  disableMoveDown: disableBottom,
  disableMoveUp: disableTop,
  isSummaryExpense = false,
}: PdfExpenseFieldsProps) {
  const buildFieldName = buildFieldExpenseNameWithIndex<PdfExpenseForm>(index);
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <Grid item xs={12}>
      <Card elevation={2}>
        <CardHeader
          action={
            <>
              <IconButton disabled={disableBottom} onClick={moveDown}>
                <ArrowDownward />
              </IconButton>
              <IconButton disabled={disableTop} onClick={moveUp}>
                <ArrowUpward />
              </IconButton>
            </>
          }
        />
        <CardContent>
          <Grid container spacing={1} justifyContent='center' alignItems='center'>
            <Grid item container spacing={1}>
              <Grid item xs={12} md={4}>
                <FormTextField
                  label='Expense type'
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  error={Boolean(errors?.expenses)}
                  helperText={errors?.expenses ? 'Expense Type is required' : ''}
                  name={buildFieldName('type')}
                  readOnly={!isSummaryExpense}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                label='Expense Notes'
                name={buildFieldName('notes')}
                multiline
                minRows={3}
                maxRows={10}
                fullWidth
              />
            </Grid>
          </Grid>
          <HiddenField name={buildFieldName('itemized')} />
          <HiddenField name={buildFieldName('quantity')} />
          <HiddenField name={buildFieldName('price')} />
          <HiddenField name={buildFieldName('extendedPrice')} />
        </CardContent>
      </Card>
    </Grid>
  );
}
